import { render, staticRenderFns } from "./Coupons.vue?vue&type=template&id=023f40b2&scoped=true"
import script from "./Coupons.vue?vue&type=script&lang=ts"
export * from "./Coupons.vue?vue&type=script&lang=ts"
import style0 from "./Coupons.vue?vue&type=style&index=0&id=023f40b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023f40b2",
  null
  
)

export default component.exports